import styles from './styles.module.css';
import DealTaxesDetailRow from './DealTaxesDetailRow';
import { Button, CloseButton, Icon } from '../../../../components';
import { DiagramDataTableShortItem } from '../../../../types/deal-taxes';
import React from 'react';
import { Icons } from '../../../../components/Icon/Icon';
import { SelectedItemAsset } from '../../../../components/SelectionPopup/SelectionPopup';
import { Asset } from '../../../../types/general';

interface DealTaxesDetailsProps {
    activeCategory: any;
    tips: DiagramDataTableShortItem[];
    onClose: () => void;
    legendChange: any;
    height?: number;
    isMultiAsset: boolean;
    asset?: Asset;
}

const DealTaxesDetails = ({
    activeCategory,
    tips,
    onClose,
    legendChange,
    height,
    isMultiAsset,
    asset,
}: DealTaxesDetailsProps) => {
    const investment = tips.filter((t) => t.stage === 'investment');
    const holding = tips.filter((t) => t.stage === 'holding');
    const distribution = tips.filter((t) => t.stage === 'distribution');
    const selling = tips.filter((t) => t.stage === 'selling');

    return (
        <div
            className={styles.box}
            // style={{
            //     height: height,
            // }}
        >
            <div className={styles.content}>
                <div className={styles.closeBtnWrapper}>
                    <button type={'button'} onClick={() => onClose()}>
                        <Icon icon={Icons.close} />
                    </button>
                </div>

                {investment.length > 0 && (
                    <DealTaxesDetailRow
                        rowTitle={'Investment'}
                        data={investment}
                        isActive={activeCategory === 'investment'}
                        legendChange={legendChange}
                        isMultiAsset={isMultiAsset}
                        asset={asset}
                    />
                )}

                {holding.length > 0 && (
                    <DealTaxesDetailRow
                        rowTitle={'Holding'}
                        data={holding}
                        isActive={activeCategory === 'holding'}
                        legendChange={legendChange}
                        isMultiAsset={isMultiAsset}
                        asset={asset}
                    />
                )}

                {distribution.length > 0 && (
                    <DealTaxesDetailRow
                        rowTitle={'Distribution'}
                        data={distribution}
                        isActive={activeCategory === 'distribution'}
                        legendChange={legendChange}
                        isMultiAsset={isMultiAsset}
                        asset={asset}
                    />
                )}

                {selling.length > 0 && (
                    <DealTaxesDetailRow
                        rowTitle={'Selling'}
                        data={selling}
                        isActive={activeCategory === 'selling'}
                        legendChange={legendChange}
                        isMultiAsset={isMultiAsset}
                        asset={asset}
                    />
                )}
            </div>
        </div>
    );
};

export default DealTaxesDetails;
